export var IdServerPing;
(function (IdServerPing) {
    IdServerPing[IdServerPing["Game"] = 240000] = "Game";
    IdServerPing[IdServerPing["ChatServer"] = 600000] = "ChatServer";
})(IdServerPing || (IdServerPing = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdServerPing.ts
// module id = 851
// module chunks = 3